/**
 * Title — the event title displayed below the player.
 *
 * Reads `event.name` from context. Config can override with an explicit
 * `text` (useful when the Director wants a different display title from
 * the canonical event name).
 */

import { registerPrimitive, type PrimitiveProps } from '../../layout'
import { useEvent } from '../../destination'

interface TitleConfig {
  /** Explicit override. Falls back to event.name when absent. */
  text?: string
}

export function EventTitle({ config }: PrimitiveProps) {
  const event = useEvent()
  const cfg = config as TitleConfig
  const text = cfg.text ?? event.name
  return <h1 className="lv-title">{text}</h1>
}

registerPrimitive('EventTitle', EventTitle)
registerPrimitive('Title', EventTitle)
